// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
}

/* UTILITY CLASSES */

/*TYPOGRAPHY */

h1 {
  font-size: 3rem;
  font-weight: 700;
}

h2 {
  font-size: 2.6rem;
  font-weight: 600;
}

h3 {
  font-size: 2rem;
  font-weight: 700;
}

h4 {
  font-size: 1.6rem;
  font-weight: 600;
}

h5 {
  font-size: 1.6rem;
  font-weight: 600;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3.5rem;
}

/* SEPARATEUR */
hr {
  opacity: 0.3;
}

hr.darkblue {
  border-top: 2px solid #484848;
}

/* FROMULAIRE */
.form-group {
  margin-bottom: 2rem;
}

.form-group label,
.form-group .label {
  display: block;
  color: #2c3948;
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
  font-weight: 600;
}

input,
select,
textarea,
select {
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  color: #2c3948;
  font-size: 12px;
  transition: border-color 0.2s ease;
}

.input-inactif {
  background-color: rgba(215, 217, 217, 0.2);
  color: #6b7280;
  cursor: not-allowed;
  padding: 1.2rem;
  border-radius: 10px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: #f97316;
}

.form-row {
  display: grid;
  gap: 2rem;
}

.view-mode .form-row {
  row-gap: 1.5rem;
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-container input {
  width: 100%;
  padding-right: 4rem;
}

/* CGV checkbox */
.cgv-container {
  margin: 20px 0;
}

.checkbox-label {
  display: flex !important;
  align-items: center;
}

.checkbox-label input {
  margin-right: 10px;
  width: fit-content !important;
}

.checkbox-label span a {
  color: #f97316;
  text-decoration: underline;
}

.cgv-checkbox {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.cgv-checkbox input[type="checkbox"] {
  width: 1.6rem;
  height: 1.6rem;
  margin: 0;
}

.cgv-checkbox label {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
  color: #2c3948;
}

.cgv-link:hover {
  text-decoration: underline;
}

.cgv-accept .cgv-label {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 400;
}

.cgv-checkbox-row {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-size: 1.6rem;
  color: #2c3948;
}

.cgv-and-actions {
  display: flex;
  align-items: flex-end;
  gap: 3rem;
  margin-top: 2rem;
}

.cgv-accept {
  flex: 1 1;
}

.form-group.cgv-accept,
.form-group.cgv-accept label,
.cgv-and-actions .action-buttons {
  margin: 0;
}

/* MESSAGE D'ERREUR */

.form-group select.error,
.error {
  border-color: #dc2626 !important;
}

.error {
  border-color: #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(217, 14, 14, 0.2);
}

.error-message {
  background-color: #fef2f2;
  color: #dc2626;
  padding: 1rem;
  border-radius: 0.6rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
}

.validation-error {
  background-color: #fee2e2;
  border: 1px solid #dc2626;
  color: #dc2626;
  padding: 1rem;
  border-radius: 0.4rem;
  margin: 1rem 0;
  font-size: 1.4rem;
}

.required {
  color: #dc2626;
  margin-left: 0.2rem;
}

textarea.error {
  border-color: #dc2626;
}

input.error {
  border-color: #dc2626;
}

/* MESSAGE SUCCESS */

.success-message {
  background-color: #ecfdf5;
  color: #059669;
  padding: 1rem;
  border-radius: 1rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
}

/* TABLEAU */

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background-color: rgba(215, 217, 217, 0.25);
}

th {
  padding: 1.5rem;
  text-align: left;
  font-weight: 600;
  color: #2c3948;
  font-size: 1.4rem;
}

td {
  padding: 1rem 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  font-size: 1.2rem;
  align-content: center;
}

td input {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.4rem;
  text-align: right;
}

tr.selected {
  background: #e0f7fa;
}

tr.highlight {
  background-color: #fef3e7;
}

/* Style pour les en-têtes de section pour qu'ils prennent toute la largeur */
.section-header td {
  font-weight: 600;
  background-color: rgba(194, 194, 194, 0.5);
  color: #2c3948;
  padding: 1rem 0.8rem;
  text-align: center;
  width: 100%; /* S'assurer que la cellule prend toute la largeur */
}

/* Assurez-vous que le colSpan est bien appliqué visuellement */
.section-header td[colspan="2"] {
  text-align: center;
  font-weight: 600;
  font-size: 1.5rem;
  padding: 1.2rem 0.8rem;
}

/* BOUTON */

.back-button,
.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  width: 30px;
}

.back-button:hover {
  transform: scale(1.05);
}

.back-button:active {
  transform: scale(0.95);
}

/* TEXT INFO */

.info-text {
  font-size: 0.95rem;
  margin: 1rem 0;
  background-color: rgba(215, 217, 217, 0.2);
  border-left: 4px solid #f97316;
  padding: 1rem;
  border-radius: 5px;
  color: #6b7280;
  font-style: italic;
}

.info-message {
  background-color: rgba(215, 217, 217, 0.2);
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  border-left: 4px solid #f97316;
}

/* GRID */

.grid-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.span-2 {
  grid-column: span 2;
}

.span-3 {
  grid-column: span 3;
}

.span-4 {
  grid-column: span 4;
}

/* GENERAL STYLES */
.section-header {
  background-color: #595959;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 1rem;
  color: #fffdfc;
  font-size: 2rem;
}

.section-header h3 {
  font-size: 1.6rem;
  color: #2c3948;
  margin: 0;
}

.form-section-block > .section-content,
.reference-card > .section-content {
  margin-bottom: 0;
}

.section-content {
  /* background: #fffdfc; */
  /* border: 1px solid #e5e7eb; */
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.consultation-info {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: rgba(249, 115, 22, 0.15);
  border-color: "#FED7AA";
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.flex-1 {
  flex: 1 1;
}

/* EPIC-46 — Hover grisé global sur les lignes de tableaux */
table tbody tr {
  transition: background-color 0.15s ease;
}

table tbody tr:hover {
  background-color: #f9fafb;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;;;;cAIY;AACd;;AAEA,oBAAoB;;AAEpB,cAAc;;AAEd;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;;;EAGE,SAAS;AACX;;AAEA,qBAAqB;;AAErB;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;;AAEpB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;;AAEZ;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,WAAW,EAAE,oDAAoD;AACnE;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,WAAW;;AAEX;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,cAAc;;AAEd;EACE,kBAAkB;EAClB,cAAc;EACd,0CAA0C;EAC1C,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,SAAS;;AAET;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA,4DAA4D;AAC5D;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".App {\r\n  font-family:\r\n    \"Inter\",\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    sans-serif;\r\n}\r\n\r\n/* UTILITY CLASSES */\r\n\r\n/*TYPOGRAPHY */\r\n\r\nh1 {\r\n  font-size: 3rem;\r\n  font-weight: 700;\r\n}\r\n\r\nh2 {\r\n  font-size: 2.6rem;\r\n  font-weight: 600;\r\n}\r\n\r\nh3 {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n}\r\n\r\nh4 {\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n}\r\n\r\nh5 {\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.page-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 3.5rem;\r\n}\r\n\r\n/* SEPARATEUR */\r\nhr {\r\n  opacity: 0.3;\r\n}\r\n\r\nhr.darkblue {\r\n  border-top: 2px solid #484848;\r\n}\r\n\r\n/* FROMULAIRE */\r\n.form-group {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.form-group label,\r\n.form-group .label {\r\n  display: block;\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n  margin-bottom: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\ninput,\r\nselect,\r\ntextarea,\r\nselect {\r\n  padding: 1.2rem;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 1rem;\r\n  color: #2c3948;\r\n  font-size: 12px;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.input-inactif {\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  color: #6b7280;\r\n  cursor: not-allowed;\r\n  padding: 1.2rem;\r\n  border-radius: 10px;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  width: 100%;\r\n}\r\n\r\ninput:focus,\r\ntextarea:focus,\r\nselect:focus {\r\n  outline: none;\r\n  border-color: #f97316;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  gap: 2rem;\r\n}\r\n\r\n.view-mode .form-row {\r\n  row-gap: 1.5rem;\r\n}\r\n\r\n.password-input-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.password-input-container input {\r\n  width: 100%;\r\n  padding-right: 4rem;\r\n}\r\n\r\n/* CGV checkbox */\r\n.cgv-container {\r\n  margin: 20px 0;\r\n}\r\n\r\n.checkbox-label {\r\n  display: flex !important;\r\n  align-items: center;\r\n}\r\n\r\n.checkbox-label input {\r\n  margin-right: 10px;\r\n  width: fit-content !important;\r\n}\r\n\r\n.checkbox-label span a {\r\n  color: #f97316;\r\n  text-decoration: underline;\r\n}\r\n\r\n.cgv-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.cgv-checkbox input[type=\"checkbox\"] {\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  margin: 0;\r\n}\r\n\r\n.cgv-checkbox label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.cgv-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.cgv-accept .cgv-label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  font-weight: 400;\r\n}\r\n\r\n.cgv-checkbox-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.7rem;\r\n  font-size: 1.6rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.cgv-and-actions {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 3rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.cgv-accept {\r\n  flex: 1;\r\n}\r\n\r\n.form-group.cgv-accept,\r\n.form-group.cgv-accept label,\r\n.cgv-and-actions .action-buttons {\r\n  margin: 0;\r\n}\r\n\r\n/* MESSAGE D'ERREUR */\r\n\r\n.form-group select.error,\r\n.error {\r\n  border-color: #dc2626 !important;\r\n}\r\n\r\n.error {\r\n  border-color: #dc2626 !important;\r\n  box-shadow: 0 0 0 1px rgba(217, 14, 14, 0.2);\r\n}\r\n\r\n.error-message {\r\n  background-color: #fef2f2;\r\n  color: #dc2626;\r\n  padding: 1rem;\r\n  border-radius: 0.6rem;\r\n  margin-bottom: 2rem;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.validation-error {\r\n  background-color: #fee2e2;\r\n  border: 1px solid #dc2626;\r\n  color: #dc2626;\r\n  padding: 1rem;\r\n  border-radius: 0.4rem;\r\n  margin: 1rem 0;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.required {\r\n  color: #dc2626;\r\n  margin-left: 0.2rem;\r\n}\r\n\r\ntextarea.error {\r\n  border-color: #dc2626;\r\n}\r\n\r\ninput.error {\r\n  border-color: #dc2626;\r\n}\r\n\r\n/* MESSAGE SUCCESS */\r\n\r\n.success-message {\r\n  background-color: #ecfdf5;\r\n  color: #059669;\r\n  padding: 1rem;\r\n  border-radius: 1rem;\r\n  margin-bottom: 2rem;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n/* TABLEAU */\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\nthead {\r\n  background-color: rgba(215, 217, 217, 0.25);\r\n}\r\n\r\nth {\r\n  padding: 1.5rem;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n}\r\n\r\ntd {\r\n  padding: 1rem 0.5rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  font-size: 1.2rem;\r\n  align-content: center;\r\n}\r\n\r\ntd input {\r\n  width: 100%;\r\n  padding: 0.8rem;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 0.4rem;\r\n  text-align: right;\r\n}\r\n\r\ntr.selected {\r\n  background: #e0f7fa;\r\n}\r\n\r\ntr.highlight {\r\n  background-color: #fef3e7;\r\n}\r\n\r\n/* Style pour les en-têtes de section pour qu'ils prennent toute la largeur */\r\n.section-header td {\r\n  font-weight: 600;\r\n  background-color: rgba(194, 194, 194, 0.5);\r\n  color: #2c3948;\r\n  padding: 1rem 0.8rem;\r\n  text-align: center;\r\n  width: 100%; /* S'assurer que la cellule prend toute la largeur */\r\n}\r\n\r\n/* Assurez-vous que le colSpan est bien appliqué visuellement */\r\n.section-header td[colspan=\"2\"] {\r\n  text-align: center;\r\n  font-weight: 600;\r\n  font-size: 1.5rem;\r\n  padding: 1.2rem 0.8rem;\r\n}\r\n\r\n/* BOUTON */\r\n\r\n.back-button,\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 1rem 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 0.2s ease;\r\n  width: 30px;\r\n}\r\n\r\n.back-button:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.back-button:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n/* TEXT INFO */\r\n\r\n.info-text {\r\n  font-size: 0.95rem;\r\n  margin: 1rem 0;\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  border-left: 4px solid #f97316;\r\n  padding: 1rem;\r\n  border-radius: 5px;\r\n  color: #6b7280;\r\n  font-style: italic;\r\n}\r\n\r\n.info-message {\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  margin-bottom: 20px;\r\n  border-left: 4px solid #f97316;\r\n}\r\n\r\n/* GRID */\r\n\r\n.grid-2 {\r\n  grid-template-columns: repeat(2, 1fr);\r\n}\r\n\r\n.grid-3 {\r\n  grid-template-columns: repeat(3, 1fr);\r\n}\r\n\r\n.grid-4 {\r\n  grid-template-columns: repeat(4, 1fr);\r\n}\r\n\r\n.span-2 {\r\n  grid-column: span 2;\r\n}\r\n\r\n.span-3 {\r\n  grid-column: span 3;\r\n}\r\n\r\n.span-4 {\r\n  grid-column: span 4;\r\n}\r\n\r\n/* GENERAL STYLES */\r\n.section-header {\r\n  background-color: #595959;\r\n  border-top-right-radius: 10px;\r\n  border-top-left-radius: 10px;\r\n  padding: 1rem;\r\n  color: #fffdfc;\r\n  font-size: 2rem;\r\n}\r\n\r\n.section-header h3 {\r\n  font-size: 1.6rem;\r\n  color: #2c3948;\r\n  margin: 0;\r\n}\r\n\r\n.form-section-block > .section-content,\r\n.reference-card > .section-content {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.section-content {\r\n  /* background: #fffdfc; */\r\n  /* border: 1px solid #e5e7eb; */\r\n  border-bottom-left-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n  padding: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.consultation-info {\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n  background-color: rgba(249, 115, 22, 0.15);\r\n  border-color: \"#FED7AA\";\r\n}\r\n.action-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.flex-1 {\r\n  flex: 1;\r\n}\r\n\r\n/* EPIC-46 — Hover grisé global sur les lignes de tableaux */\r\ntable tbody tr {\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\ntable tbody tr:hover {\r\n  background-color: #f9fafb;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
